import { Avatar, Grid, Paper, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import copyIcon from "../../assets/USA_Images/copyIcon.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";

function KeyConfigView(props) {
  const { t } = useTranslation();
  const loginDetails = props.location.state.loginDetailsDTOV4s || [];
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(loginDetails.length);
  const [totalPages, setTotalPages] = useState(1);

  const rows = loginDetails.map((detail, index) => ({
    id: index + 1,
    deviceType: detail?.deviceType,
    deviceNameOS: detail?.deviceName,
    osModel: detail?.deviceOSVersion,
    hardwareId: Array.isArray(detail.deviceIds)
      ? detail.deviceIds.join(", ")
      : detail?.deviceId,
    latitudeAndLongitude:
      detail?.latitude == null || detail?.longitude == null
        ? " "
        : `${detail?.latitude} ${detail?.longitude}`,
  }));

  const columns = [
    { field: "id", headerName: "S.No", width: 150 },
    { field: "deviceType", headerName: "Device Type", width: 300 },
    { field: "deviceNameOS", headerName: "Device Name OS", width: 300 },
    { field: "osModel", headerName: "OS Version", width: 300 },
    {
      field: "hardwareId",
      headerName: "Hardware ID",
      width: 400,
      renderCell: (params) => (
        <Tooltip title={params.value || ""} placement="bottom-end">
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            {params.value || ""}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "latitudeAndLongitude",
      headerName: "Latitude & Longitude",
      width: 200,
      renderCell: (params) => (
        <Tooltip title={params.value || ""} placement="bottom-end">
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            {params.value || ""}
          </span>
        </Tooltip>
      ),
    },
  ];

  useEffect(() => {
    const pages = Math.ceil(totalRecords / pageSize);
    setTotalPages(pages || 1);
  }, [loginDetails, pageSize, totalRecords]);

  const [copied, setCopied] = useState(false);

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => setCopied(true))
      .catch((error) => console.error("Error copying text: ", error));
  };

  const generateActivationKeyText = (platform) => {
    const iosKeys = `
      Pdf Detector Activation Key: ${props.location.state.pdfDetectorActivationKey}
      Pdf Parser Activation Key: ${props.location.state.pdfParserActivationKey}
      Mrz Detector Activation Key: ${props.location.state.mrzDetectorActivationKey}
     
    `;
    const androidKeys = `
      Pdf Detector Activation Key: ${props.location.state.privateConstValScannerKey}
      Pdf Parser Activation Key: ${props.location.state.privateConstValParserKey}
      Mrz Detector Activation Key: ${props.location.state.androidMRZDetectionActivationKey}
    `;
    return platform === "ios" ? iosKeys : androidKeys;
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPageSize(size);
  };

  const paginatedRows = rows.slice((page - 1) * pageSize, page * pageSize);

  return (
    <>
      <HeaderToolbar title={t("KEYCONFIGURATIONVIEW")} back_button={true} />
      <Paper
        style={{
          backgroundColor: "#fff",
          height: "calc(100vh - 150px)",
          overflowY: "auto",
          marginTop: "14px",
        }}
      >
        <Grid container spacing={3} padding={2}>
          <Grid
            item
            xs={12}
            sm={4}
            md={3}
            lg={3}
            xl={2}
            style={{ textAlign: "center" }}
          >
            <Avatar
              alt={props.location.state.firstName}
              src={
                props.location.state.imagePreSignedURL !== undefined
                  ? props.location.state.imagePreSignedURL
                  : null
              }
              sx={{ height: "180px", width: "180px", margin: "auto" }}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={8}
            md={4}
            lg={4}
            xl={5}
            sx={{ borderRight: { md: "3px solid #E1E9F5", sm: "none" } }}
          >
            {[
              {
                label: t("DEALERFIRSTNAME"),
                value: props.location.state.firstName,
              },
              {
                label: t("DEALERLASTNAME"),
                value: props.location.state.lastName,
              },
              {
                label: t("DEALEREMAIL"),
                value: props.location.state.customerEmail,
              },
              {
                label: t("VIEWPAGEMOBLIENUMBER"),
                value: props.location.state.customerMobile,
              },
              {
                label: t("CUSTDATABLE22"),
                value: props.location.state.dealerName,
              },
            ].map((field, index) => (
              <Grid
                container
                key={field.label}
                sx={{ mt: index === 0 ? 0 : 2 }}
                alignItems="center"
              >
                <Grid
                  item
                  xs={5}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    pr: 1,
                  }}
                >
                  <Typography
                    noWrap
                    sx={{ opacity: 0.7, fontWeight: 500, flexShrink: 0 }}
                  >
                    {field.label}
                  </Typography>
                  <Typography
                    sx={{ opacity: 0.7, fontWeight: 500, flexShrink: 0 }}
                  >
                    :
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={field.value} placement="bottom-start">
                    <Typography noWrap>{field.value}</Typography>
                  </Tooltip>
                </Grid>
              </Grid>
            ))}
          </Grid>

          <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
            {[
              {
                label: t("DEALERCOMPANYNAME"),
                value: props.location.state.customerName,
              },
              {
                label: t("CUSTDATABLE04"),
                value: `${props.location.state.firstName} ${props.location.state.lastName}`,
              },
              {
                label: t("LABELNAVITEMSSUBSCRIPTION"),
                value: `${props.location.state.customerSubscriptionName}${
                  props.location.state.subscriptionMode !== null
                    ? `/${props.location.state.subscriptionMode}`
                    : ""
                }`,
              },
              {
                label: t("KEYCONFIGURATIONNUMBERNOT"),
                value: props.location.state.numberOfDevices,
              },
            ].map((field, index) => (
              <Grid
                container
                key={field.label}
                sx={{ mt: index === 0 ? 0 : 2 }}
                alignItems="center"
              >
                <Grid
                  item
                  xs={5}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    pr: 1,
                  }}
                >
                  <Typography
                    noWrap
                    sx={{ opacity: 0.7, fontWeight: 500, flexShrink: 0 }}
                  >
                    {field.label}
                  </Typography>
                  <Typography
                    sx={{ opacity: 0.7, fontWeight: 500, flexShrink: 0 }}
                  >
                    :
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={field.value} placement="bottom-start">
                    <Typography noWrap>{field.value}</Typography>
                  </Tooltip>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/**IOS KEY COPY */}
        <Grid
          item
          xs={12}
          sm={4}
          md={3}
          lg={3}
          xl={2}
          style={{ marginLeft: "10px", marginTop: "10px" }}
        >
          <Typography>
            <b>{t("CUSTDATABLE31")}:</b> &nbsp;
            <Tooltip title={t("COPY_TOOL_TIP")}>
              <img
                style={{
                  height: "20px",
                }}
                alt="Copy"
                src={copyIcon}
                onClick={() => handleCopy(generateActivationKeyText("ios"))}
              />
            </Tooltip>
          </Typography>
          <Typography sx={{ marginTop: "14px" }}>
            {t("KEYCONFIGURATIONIOSKEYPDF")} :{" "}
            {props.location.state.pdfDetectorActivationKey}
          </Typography>
          <Typography sx={{ marginTop: "14px" }}>
            {t("KEYCONFIGURATIONIOSKEYPDFPARSER")} :{" "}
            {props.location.state.pdfParserActivationKey}
          </Typography>
          <Typography sx={{ marginTop: "14px" }}>
            {t("KEYCONFIGURATIONIOSKEYMRZ")} :{" "}
            <Tooltip
              title={props.location.state?.mrzDetectorActivationKey || ""}
            >
              <span>
                {props.location.state?.mrzDetectorActivationKey &&
                props.location.state.mrzDetectorActivationKey?.length > 100
                  ? `${props.location.state?.mrzDetectorActivationKey.substring(
                      0,
                      100
                    )}...`
                  : props.location.state?.mrzDetectorActivationKey}
              </span>
            </Tooltip>
          </Typography>
        </Grid>
        {/**ANDIROD KEY COPY */}
        <Grid
          item
          xs={12}
          sm={4}
          md={3}
          lg={3}
          xl={2}
          style={{ marginLeft: "10px", marginTop: "20px" }}
        >
          <Typography>
            <b>{t("CUSTDATABLE32")}:</b> &nbsp;
            <Tooltip title={t("COPY_TOOL_TIP")}>
              <img
                style={{
                  height: "20px",
                }}
                alt="Copy"
                src={copyIcon}
                onClick={() => handleCopy(generateActivationKeyText("android"))}
              />
            </Tooltip>
          </Typography>
          <Typography sx={{ marginTop: "14px" }}>
            {t("KEYCONFIGURATIONIOSKEYPDF")} :{" "}
            <Tooltip title={props.location?.state?.privateConstValScannerKey}>
              <span>
                {props.location?.state?.privateConstValScannerKey?.length > 90
                  ? `${props.location?.state?.privateConstValScannerKey.substring(
                      0,
                      90
                    )}...`
                  : props.location?.state?.privateConstValScannerKey}
              </span>
            </Tooltip>
          </Typography>
          <Typography sx={{ marginTop: "14px" }}>
            {t("KEYCONFIGURATIONIOSKEYPDFPARSER")} :{" "}
            <Tooltip title={props.location?.state?.privateConstValParserKey}>
              <span>
                {props.location?.state?.privateConstValParserKey?.length > 90
                  ? `${props.location?.state?.privateConstValParserKey.substring(
                      0,
                      90
                    )}...`
                  : props.location?.state?.privateConstValParserKey}
              </span>
            </Tooltip>
          </Typography>
          <Typography sx={{ marginTop: "14px" }}>
            {t("KEYCONFIGURATIONIOSKEYMRZ")} :{" "}
            <Tooltip
              title={props.location?.state?.androidMRZDetectionActivationKey}
            >
              <span>
                {props.location?.state?.androidMRZDetectionActivationKey
                  ?.length > 90
                  ? `${props.location?.state?.androidMRZDetectionActivationKey.substring(
                      0,
                      90
                    )}...`
                  : props.location?.state?.androidMRZDetectionActivationKey}
              </span>
            </Tooltip>
          </Typography>
        </Grid>
        {/* Device History Table */}
        <Grid
          item
          xs={12}
          sm={4}
          md={3}
          lg={3}
          xl={2}
          style={{ marginLeft: "10px", marginTop: "20px" }}
        >
          <Typography>
            <b>{t("VIEWPAGEKEYCONFIGURATIONDEVICEHISTORY")}:</b>
          </Typography>
          <div style={{ width: "99%", height: 100, marginTop: "10px" }}>
            <DataTableLatest
              columns={columns}
              rows={paginatedRows}
              page={page}
              rowId={(row) => row.id}
              emergencyMsg={true}
              count={totalRecords}
              pageCount={totalPages}
              pageSize={pageSize}
              handleChange={(newPage, size) => handleChange(newPage, size)}
            />
          </div>
        </Grid>
      </Paper>
    </>
  );
}

export default KeyConfigView;
